export const HOTEL_SELECTION_LOCAL_STORAGE_KEY = (eventId: string) => `${eventId}_hotelSelectionCart`;
export const MAX_HOTELS_IN_CART = 5;
export const MAX_HOTELS_IN_CART_BEFORE_CONFIRM = 1;
